<script setup>
import { ref, computed } from "vue";
import { useI18n } from "vue-i18n";
import SponsoredBadge from '@/components/ui/sponsored_badge.vue'

const props = defineProps({
    includeSponsored: {
        type: Boolean,
        default: false
    },
    sponsoredTier: {
        type: Number,
        default: 0
    }
})

// I18n
const { t } = useI18n();

// Variables
const cardClass = computed(() => {
    let classes = 'card';
    if (props.sponsoredTier > 0) {
        classes += ' sponsored-card';
        if (props.sponsoredTier === 1) classes += ' sponsored-bronze-border';
        if (props.sponsoredTier === 2) classes += ' sponsored-gold-border';
    }
    return classes;
});

</script>

<template>
    <div class="w-full p-2 py-4">
        <div :class="cardClass + ' w-full border border-black rounded-xl relative'">
            <!-- Sponsored Badge -->
            <div v-if="sponsoredTier > 0" class="absolute -top-3 left-1/2 transform -translate-x-1/2 z-10">
                <SponsoredBadge :tier="sponsoredTier" size="small" />
            </div>
            <slot></slot>
        </div>
    </div>
</template>


<style lang="scss" scoped>
@import '@/assets/styles/views/service_providers/service_providers_card_base';
</style>
